import styled, { keyframes } from 'styled-components';

const pulseRing = keyframes`
  0%, 100% { transform: scale(1);   opacity: 0.85; }
  50%      { transform: scale(1.8); opacity: 0; }
`;

const shimmer = keyframes`
  0%   { background-position: -200% 0; }
  100% { background-position: 200% 0; }
`;

const Wrap = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 3px 10px 3px 8px;
  border-radius: ${({ theme }) => theme.radius.pill};
  background: ${({ theme }) => theme.colors.status.success}1a;
  color: ${({ theme }) => theme.colors.status.success};
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  position: relative;
  overflow: hidden;
  border: 1px solid ${({ theme }) => theme.colors.status.success}40;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(
      90deg,
      transparent 0%,
      ${({ theme }) => theme.colors.status.success}22 50%,
      transparent 100%
    );
    background-size: 200% 100%;
    animation: ${shimmer} 1.8s linear infinite;
    pointer-events: none;
  }
`;

const DotWrap = styled.span`
  position: relative;
  width: 8px;
  height: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const Dot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.status.success};
  z-index: 1;
`;

const Ring = styled.span`
  position: absolute;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.status.success};
  animation: ${pulseRing} 1.4s ease-out infinite;
`;

interface Props {
  label?: string;
}

/**
 * Бэйдж «идёт анализ» с пульсирующей зелёной точкой и shimmer-фоном.
 * Используется в списке договоров и шапке карточки, когда LLM перепроверяет
 * договор — чтобы юрист видел, что система работает, даже не открыв модалку.
 */
export function AnalyzingBadge({ label = 'Анализируется' }: Props) {
  return (
    <Wrap>
      <DotWrap>
        <Ring />
        <Dot />
      </DotWrap>
      <span>{label}</span>
    </Wrap>
  );
}
